import { useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';

import { useCartProvider } from '../providers/cartProvider';

import PaymentFormView from './PaymentFormView';

type CheckoutInnerModalProps = {
    clientSecret: string;
    submitTrigger: number;
};

function PaymentSteps(props: CheckoutInnerModalProps): React.JSX.Element {
    const { clientSecret, submitTrigger } = props;

    const [message, setMessage] = useState<string | null>(null);

    const { cartUuid, setPaidCartUuid, reloadCart, setCurrentStep: setStep } = useCartProvider();

    const stripe = useStripe();

    useEffect(() => {
        if (!stripe) {
            console.error('PaymentSteps.tsx Error: No stripe instance!');
            return;
        }

        if (!clientSecret) {
            console.error('PaymentSteps.tsx Error: No client secret!');
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent, error }) => {
            if (error) {
                console.error('PaymentSteps.tsx retrievePaymentIntent Error:', error);
            }
            switch (paymentIntent?.status) {
                case 'succeeded':
                    setStep('03_payment_complete');
                    break;
                case 'processing':
                    setMessage('Your payment is processing.');
                    break;
                case 'requires_payment_method':
                    // setMessage('Please select a payment method.');
                    break;
                default:
                    setMessage('Something went wrong.');
                    break;
            }
        });
        // eslint-disable-next-line
    }, [stripe]);

    return (
        <PaymentFormView
            paymentStatusMessage={message}
            clientSecret={clientSecret}
            submitTrigger={submitTrigger}
            onPaymentComplete={() => {
                reloadCart();
                setPaidCartUuid(cartUuid);
                setStep('03_payment_complete');
            }}
        />
    );
}

export default PaymentSteps;
